import type { AdLandingMode } from '../utils/adLandingIntent';

const AD_HERO_BASE_URL = 'https://media.sarvalok.com/ad-hero';

export const AD_HERO_IMAGES: Record<AdLandingMode, string[]> = {
  astro: [
    `${AD_HERO_BASE_URL}/astro/astrologermonk.webp`,
    `${AD_HERO_BASE_URL}/astro/astrosolar.webp`,
    `${AD_HERO_BASE_URL}/astro/astrowestern.webp`,
    `${AD_HERO_BASE_URL}/astro/birthchart.webp`,
    `${AD_HERO_BASE_URL}/astro/jyotishacheck.webp`,
  ],
  'scriptures-and-sanskrit': [
    `${AD_HERO_BASE_URL}/scriptures/manuscript.webp`,
    `${AD_HERO_BASE_URL}/scriptures/plammanuscripts.webp`,
    `${AD_HERO_BASE_URL}/scriptures/ramayana.webp`,
    `${AD_HERO_BASE_URL}/scriptures/sanskritinscription.webp`,
  ],
  'philosophy-and-vedanta': [
    `${AD_HERO_BASE_URL}/philosophy/meenakshi.webp`,
    `${AD_HERO_BASE_URL}/philosophy/templearchitecture.webp`,
    `${AD_HERO_BASE_URL}/philosophy/vedantaarchitecture.webp`,
    `${AD_HERO_BASE_URL}/philosophy/vedantaarchitecture2.webp`,
  ],
  'yoga-meditation-ayurveda': [
    `${AD_HERO_BASE_URL}/yoga/ayurveda1.webp`,
    `${AD_HERO_BASE_URL}/yoga/ayurveda2.webp`,
    `${AD_HERO_BASE_URL}/yoga/ayurveda3.webp`,
    `${AD_HERO_BASE_URL}/yoga/mudra.webp`,
    `${AD_HERO_BASE_URL}/yoga/yoga.webp`,
    `${AD_HERO_BASE_URL}/yoga/Yoganataraja.webp`,
  ],
  'global-risk': [],
};

export function pickRandomHeroImage(mode: AdLandingMode): string | null {
  const images = AD_HERO_IMAGES[mode];
  if (images.length === 0) return null;
  return images[Math.floor(Math.random() * images.length)];
}

export function pickRandomVariantIndex(variantCount: number): number {
  if (variantCount <= 1) return 0;
  return Math.floor(Math.random() * variantCount);
}
